<template>
<div >
  <div @click="handleClick" class="arrow" :style="style" v-if="realtimeData.state === true && mode === 'view'">
    <div class="text">{{text}}</div>
  </div>
  <div :style="style" v-if="mode === 'edit'">
    <div class="text">{{text}}</div>
  </div>
  <el-dialog :style="dialogStyle"
      title="子窗口页面"
      :visible.sync="modalShow"
      :width="realtimeData.modalValue+'px'"
      @close="modalShow=false"
      append-to-body>
    <div :style="modelStyle">
      <div style="width: 100%; ">
        <the-create style="width: 100%;" :companyId="companyId" :productId="realtimeData.pageId" :projectId="productSaveForm.projectId" :editType="3" :dialogCount="dialogCount+1" :readPublished="true"></the-create>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import componentsMixin from "../componentsMixin";

export default {
  name: 'arrowComponent',
  mixins: [componentsMixin],
  data(){
    return{
      colorFlag: 0,
    }
  },
  methods: {

    flashArrow(){
      this._style["animation-play-state"] = 'running'
      this.settings.flash = true
      this.newSettings.flash = true
    },
    //取消闪烁
    stopFlashArrow(){
      this._style["animation-play-state"] = 'paused'
      this.settings.flash = false
      this.newSettings.flash = false
    },
    //箭头消失
    disappearArrow(){
      // if(this.settings.state == true){
      // this._style['border-color'] = 'transparent'
      // this.settings.state = false
      // }
      // this.newSettings.state = false
      this.settings.state = false
    },
    //箭头出现
    appearArrow(){
      // if(this.settings.state == false){
      // this._style['border-color'] = this.settings.arrowColor
      // this.settings.state = true
      // }
      // this.newSettings.state = false
      this.settings.state = true
    }
  },
  computed: {
    text() {
      return this.dynamicProps.dynamicText
    },

    dialogStyle(){
      //一开始想要 X和Y用%作单位，并且用百分数减去自身宽度高度的一半，但是初始的eldialog的高度没设置不知道
      // if(this.realtimeData.modalValue.length ==0 || this.realtimeData.modalHeight.length == 0){
      //    return //此处没写完
      // }else{
      //   if(this.realtimeData.modalX.length == 0 && this.realtimeData.modalY.length == 0){
      //     var applyLeft = `calc(50% - ${this.realtimeData.modalValue/2}px)`
      //     var applyTop =  `calc(50% - ${this.realtimeData.modalHeight/2}px)`
      //   }if(this.realtimeData.modalX.length !== 0 && this.realtimeData.modalY.length == 0){
      //     var applyLeft = `calc(${this.realtimeData.modalX}% - ${this.realtimeData.modalValue/2}px)`
      //     var applyTop = `calc(50% - ${this.realtimeData.modalHeight/2}px)`
      //   }if(this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length == 0){
      //     var applyLeft = `calc(50% - ${this.realtimeData.modalValue/2}px)`
      //     var applyTop = `calc(${this.realtimeData.modalY}% - ${this.realtimeData.modalHeight/2}px)`
      //   }if(this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length !== 0){
      //     var applyLeft = `calc(${this.realtimeData.modalX}% - ${this.realtimeData.modalValue/2}px)`
      //     var applyTop = `calc(${this.realtimeData.modalY}% - ${this.realtimeData.modalHeight/2}px)`
      //   }
      // }
      //所以现在直接用px作单位并且不减去自身的高度了
      if(this.realtimeData.modalX === undefined && this.realtimeData.modalY === undefined ){
        var applyLeft = '0'
        var applyTop = '0'
      } else if(this.realtimeData.modalX.length == 0 && this.realtimeData.modalY.length == 0){
        var applyLeft = '0'
        var applyTop = '0'
      }else if(this.realtimeData.modalX.length !== 0 && this.realtimeData.modalY.length == 0){
        var applyLeft = this.realtimeData.modalX
        var applyTop = '0'
      } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length == 0) {
        var applyLeft = '0'
        var applyTop = this.realtimeData.modalY
      } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length !== 0) {
        var applyLeft = this.realtimeData.modalX
        var applyTop = this.realtimeData.modalY
      }
      return {
        //将元素向左上移动其自身宽度和高度的50%，这个技术通常用于元素居中
        // transform:'translate(-50%,-50%)',
        top:`calc(${applyTop}px + 10vh)`,
        left: applyLeft + 'px',
      }
    },

  },
  watch: {
    'realtimeData.arrowColor': {  // 颜色绑定
      handler() {
        this._style["background-color"] = this.realtimeData.arrowColor
      }
    },
    'realtimeData.arrowSize': {  // 大小绑定
      handler() {
        this._style["border-width"] = this.realtimeData.arrowSize + 'px'
      }
    },
    // 'realtimeData.top': {  // x绑定
    //   handler() {
    //     this.wrapperStyle.top = this.realtimeData.top +'px'
    //   }
    // },
    // 'realtimeData.left': {  // y绑定
    //   handler() {
    //     this.wrapperStyle.left = this.realtimeData.left +'px'
    //   }
    // },
    // 'realtimeData.height': {  // 高度绑定
    //   handler() {
    //     this._style.height = this.realtimeData.height + 'px'  // componentsMixin 中对 _style 进行了检查更新style 绑定至矩形框
    //     this.wrapperStyle.height = this.realtimeData.height +'px'
    //   }
    // },
    // 'realtimeData.width': {  // 宽度绑定
    //   handler() {
    //     console.log("宽度发生改变",this.realtimeData.width,this.style)
    //     this._style.width = this.realtimeData.width + 'px'
    //     this.wrapperStyle.width = this.realtimeData.width +'px'  // 编辑框
    //   }
    // },
  }
}
</script>

<style lang="less" scoped>
@keyframes twinkle {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.arrow{
  animation-name: twinkle;
  animation-timing-function: ease-in-out;
  /*动画以低速开始，并以低速结束*/
  animation-iteration-count:infinite;
}
//::v-deep .el-dialog{
//  margin:0 !important;
//  position:absolute;
//  top:50%;
//  left:50%;
//  //将元素向左上移动其自身宽度和高度的50%，这个技术通常用于元素居中
//  transform:translate(-50%,-50%);
//}
::v-deep .el-dialog{
  margin:0 !important;
  position:absolute;
}
</style>
